module.exports = __webpack_public_path__ + "a900de2d3ffd2b3f68a6bd3daabd84ae.png";